import "./Footer.css";
import {
  Facebook,
  Instagram,
  MapPin,
  Phone,
  MessageCircle,
} from "lucide-react";

import { useTranslation } from "react-i18next"; // Importing the translation hook

export default function Footer() {
  const { t } = useTranslation(); // Using the translation function

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo & About */}
        <div className="footer-col">
          <img
            src="images/logo.png"
            alt="HouseTech Logo"
            className="footer-logo"
          />
          <h5>House Technology Trading</h5>
          <p className="footer-desc">{t("footer.desc")}</p>

          <div className="social-links">
            <a
              href="https://www.facebook.com/HouseTechnologyTradingLLC/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook size={18} />
            </a>

            <a
              href="https://www.instagram.com/housetechuae/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram size={18} />
            </a>

            {/* TikTok */}
            <a
              href="https://www.tiktok.com/@housetechuae"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M21 7.2c-1.9 0-3.6-.6-5-1.6v9.4a6.8 6.8 0 1 1-6.8-6.8c.3 0 .6 0 .9.1v3.5a3.3 3.3 0 1 0 2.4 3.2V1h3.5c.3 2.6 2.2 4.7 4.8 5.1v1.1z" />
              </svg>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/+9710589445296"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 32 32"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M16 0C7.2 0 0 7.2 0 16c0 2.8.7 5.5 2.1 7.9L0 32l8.3-2.1c2.3 1.3 4.9 2 7.7 2 8.8 0 16-7.2 16-16S24.8 0 16 0zm0 29.3c-2.4 0-4.7-.6-6.7-1.8l-.5-.3-4.9 1.3 1.3-4.7-.3-.5A13.2 13.2 0 1 1 16 29.3zm7.5-9.9c-.4-.2-2.2-1.1-2.6-1.2-.4-.1-.6-.2-.9.2s-1 1.2-1.2 1.4c-.2.2-.4.3-.8.1s-1.6-.6-3.1-2c-1.2-1-2-2.3-2.2-2.7-.2-.4 0-.6.2-.8.2-.2.4-.4.6-.7.2-.2.3-.4.4-.6.1-.2 0-.4 0-.6-.1-.2-.9-2.1-1.2-2.8-.3-.7-.6-.6-.9-.6h-.8c-.3 0-.7.1-1 .4-.3.3-1.3 1.2-1.3 3s1.3 3.5 1.5 3.8c.2.3 2.6 4 6.4 5.5.9.4 1.6.6 2.1.7.9.3 1.7.2 2.4.1.7-.1 2.2-.9 2.5-1.8.3-.9.3-1.6.2-1.8-.1-.2-.3-.3-.7-.5z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Navigation */}
        <div className="footer-col">
          <h4> {t("footer.nav")}</h4>
          <ul>
            <li>
              <a href="/"> {t("footer.home")}</a>
            </li>
            <li>
              <a href="/products"> {t("footer.products")}</a>
            </li>
            <li>
              <a href="/smartdeals"> {t("footer.smartDeals")}</a>
            </li>
            <li>
              <a href="/about"> {t("footer.about")}</a>
            </li>
            <li>
              <a href="/faq"> {t("footer.faq")}</a>
            </li>
          </ul>
        </div>

        {/* Smart Products */}
        <div className="footer-col">
          <h4>{t("footer.smartProducts")}</h4>
          <ul>
            <li>
              <a href="#">{t("footer.smartLighting")}</a>
            </li>
            <li>
              <a href="#">{t("footer.smartLocks")}</a>
            </li>
            <li>
              <a href="#">{t("footer.videoIntercom")}</a>
            </li>
            <li>
              <a href="#">{t("footer.securityCameras")}</a>
            </li>
            <li>
              <a href="#">{t("footer.smartCurtains")}</a>
            </li>
            <li>
              <a href="#">{t("footer.homeAutomation")}</a>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4>{t("footer.contact")}</h4>

          <p className="contact-item">
            <a href="tel:+971555895194" aria-label="Phone" className="link">
              <a href="tel:+971555895194" aria-label="Phone">
                <Phone size={16} />
              </a>
              <span className="text">{t("footer.phone")}</span>
            </a>
          </p>

          <p className="contact-item">
            {/* WhatsApp */}
            <a
              href="https://wa.me/+9710589445296"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="link"
            >
              <a
                href="https://wa.me/+9710589445296"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 32 32"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16 0C7.2 0 0 7.2 0 16c0 2.8.7 5.5 2.1 7.9L0 32l8.3-2.1c2.3 1.3 4.9 2 7.7 2 8.8 0 16-7.2 16-16S24.8 0 16 0zm0 29.3c-2.4 0-4.7-.6-6.7-1.8l-.5-.3-4.9 1.3 1.3-4.7-.3-.5A13.2 13.2 0 1 1 16 29.3zm7.5-9.9c-.4-.2-2.2-1.1-2.6-1.2-.4-.1-.6-.2-.9.2s-1 1.2-1.2 1.4c-.2.2-.4.3-.8.1s-1.6-.6-3.1-2c-1.2-1-2-2.3-2.2-2.7-.2-.4 0-.6.2-.8.2-.2.4-.4.6-.7.2-.2.3-.4.4-.6.1-.2 0-.4 0-.6-.1-.2-.9-2.1-1.2-2.8-.3-.7-.6-.6-.9-.6h-.8c-.3 0-.7.1-1 .4-.3.3-1.3 1.2-1.3 3s1.3 3.5 1.5 3.8c.2.3 2.6 4 6.4 5.5.9.4 1.6.6 2.1.7.9.3 1.7.2 2.4.1.7-.1 2.2-.9 2.5-1.8.3-.9.3-1.6.2-1.8-.1-.2-.3-.3-.7-.5z" />
                </svg>
              </a>
              <span className="text">{t("footer.whatsapp")}</span>
            </a>
          </p>

          <p className="contact-item">
            <div className="location">
              <a
                href="https://www.google.com/maps/search/?api=1&query=Al+Kazim+Building+Al+Garhoud+Dubai"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Location"
                className="link"
              >
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Al+Kazim+Building+Al+Garhoud+Dubai"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Location"
                >
                  <MapPin size={16} />
                </a>
                <span className="text">{t("footer.location")}</span>
              </a>
            </div>
          </p>
        </div>

        {/* Send Message */}
        <div className="footer-col">
          <h4>{t("footer.send")}</h4>

          <form className="footer-form">
            <input type="email" placeholder={t("footer.email")} />
            <textarea placeholder={t("footer.msg")} />
            <button type="submit">{t("footer.btn")}</button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">{t("footer.text")}</div>

      <div
        className="by"
        style={{
          textAlign: "Center",
          marginTop: "20px",
          fontSize: "10px",
          color: "#82898f",
        }}
      >
        Developed and Designed by
        <a
          href="http://snakecode.io/"
          rel="noopener noreferrer"
          target="_blank"
          style={{
            color: "#b0b5bd",
            textDecoration: "none",
            marginLeft: "5px",
          }}
        >
          Snake Code
        </a>
      </div>
    </footer>
  );
}
